import type { NextPage } from 'next'
import { FAQ } from '@/client/modules/FAQ'
import { FAQProps } from '@/client/modules/FAQ/types'
import { getCMSContent } from '@/client/utils'

const FAQPage: NextPage<FAQProps> = (data) => <FAQ {...data} />

export async function getStaticProps({ defaultLocale, locale }) {
  const data = await getCMSContent(defaultLocale, locale, 'FAQ')

  if (!data?.content) return { revalidate: 60, notFound: true }

  return {
    revalidate: 10,
    props: { ...data }
  }
}

export default FAQPage
